import { FromPriceConfig } from "@/hooks/useFromPrice";

/**
 * Representative plan configs used to resolve the "From $X / mo" /
 * "Starting from" anchor prices shown on the customize proxy tabs and the
 * "Most popular plans" upsell cards.
 *
 * Prices for these configs come from `/subscription/pricing/` (via
 * {@link useFromPrice}) so they always match what the backend actually charges
 * — including any active pricing experiments — instead of being hardcoded.
 *
 * Note: "Verified" plans are intentionally absent. They are custom-quoted, the
 * pricing endpoint does not serve them, and the customize page itself skips the
 * pricing fetch for them, so their anchor cannot be derived here.
 */
export const ENTRY_PLAN_CONFIGS = {
  datacenter: {
    proxyType: "shared",
    proxySubtype: "default",
    proxyCount: 100,
    bandwidth: 250,
  },
  staticResidential: {
    proxyType: "shared",
    proxySubtype: "isp",
    proxyCount: 20,
    bandwidth: 250,
  },
  rotatingResidential: {
    proxyType: "shared",
    proxySubtype: "residential",
    proxyCount: 80000000,
    bandwidth: 1,
  },
} satisfies Record<string, FromPriceConfig>;
